module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row spinner-parent"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Order Video")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary btn-sm pull-right",
    attrs: {
      "to": {
        name: 'VideoSeriesManageVideos',
        params: {
          id: _vm.$route.params.id
        }
      }
    }
  }, [_vm._v("\n          Manage Video\n        ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "card-block spinner-parent"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), _c('SlickList', {
    staticClass: "slicksort-wrap",
    attrs: {
      "lock-axis": "y"
    },
    model: {
      value: (_vm.tracks),
      callback: function($$v) {
        _vm.tracks = $$v
      },
      expression: "tracks"
    }
  }, _vm._l((_vm.tracks), function(track, index) {
    return _c('SlickItem', {
      key: index,
      staticClass: "slicksort-item",
      attrs: {
        "index": index
      }
    }, [_vm._v("\n            " + _vm._s(track.title) + "\n          ")])
  }), 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "mb-5"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n        Save\n        "), _c('span', {
    ref: "saveBtnLoader",
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "saving-alerts",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          Order has changed successful!\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.saveErrorMessage) + "\n        ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h1', [_vm._v("Video Series")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f71f08a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/content/videoSeries/OrderVideos.vue
// module id = 836
// module chunks = 0